import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Button, Tooltip } from '@bufferapp/ui';
import { getColorContrast } from '~/shared-components/ColorPicker/utils/HexValidations';
import { ConditionalWrapper } from '~/shared-components';

import truncateText from '../../utils/truncateText';

const TagButton = styled(Button)`
  margin-left: 16px;
  margin-bottom: 16px;
  height: initial;
  opacity: ${(props) => (props.dragging ? 0 : 1)};
  background-color: ${(props) => props.color};
  border-color: ${(props) => props.color};
  :hover {
    background-color: ${(props) => props.color};
    color: ${(props) => props.textColor};
    border-color: ${(props) => props.color};
    opacity: 0.9;
  }
  color: ${(props) => props.textColor};
`;

const PostTag = ({ name, color, dragging, onPostTagClick }) => {
  const wasTruncated = name !== truncateText(name, 25);

  return (
    <div>
      <ConditionalWrapper
        condition={wasTruncated}
        wrapper={(children) => (
          <Tooltip label={name} position="top">
            {children}
          </Tooltip>
        )}
      >
        <TagButton
          size="small"
          type="primary"
          onClick={onPostTagClick}
          label={truncateText(name, 25)}
          dragging={dragging}
          color={color}
          textColor={getColorContrast(color)}
        />
      </ConditionalWrapper>
    </div>
  );
};

PostTag.propTypes = {
  name: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  dragging: PropTypes.bool.isRequired,
  onPostTagClick: PropTypes.func.isRequired,
};

export default PostTag;
